import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"


const __default__ = {
  inheritAttrs: false
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'VBackdrop',
  props: {
    show: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { show: boolean }






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "exp-backdrop" }, {
      default: _withCtx(() => [
        (props.show)
          ? (_openBlock(), _createElementBlock("div", _mergeProps({
              key: 0,
              class: "exp-backdrop exp-app",
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('close')), ["self"]))
            }, _ctx.$attrs), [
              _renderSlot(_ctx.$slots, "default")
            ], 16))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})